import React, { useState, useEffect } from "react";
import Sidebar from "../../components/navigation/SideBar/SideBar";
import { Outlet } from "react-router-dom";
import { MdClose, MdDehaze } from "react-icons/md";

function Layout() {
  const [showSidebar, setShowSidebar] = useState(false); // collapsed on desktop
  const [show, setShow] = useState(false); // open on mobile
  const [showCancelButton, setShowCancelButton] = useState(false);

  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";
    return () => { document.body.style.overflow = "auto"; };
  }, [show]);

  return (
    <div className="min-h-screen bg-mainColor">

      {/* ════════════════════════════════════════
          DESKTOP  (laptopM and above)
          Sidebar fixed on left, content scrolls right
      ════════════════════════════════════════ */}
      <div className="hidden laptopM:flex min-h-screen">

        {/* Fixed sidebar column */}
        <div
          className={`flex-shrink-0 relative transition-all duration-300 ease-in-out ${showSidebar ? "w-16" : "w-64"
            }`}
        >
          {/* Sidebar is sticky/fixed inside this column */}
          <div className="fixed top-0 left-0 h-screen transition-all duration-300 ease-in-out z-30"
            style={{ width: showSidebar ? "4rem" : "16rem" }}>
            <Sidebar
              showSidebar={showSidebar}
              setShowSidebar={setShowSidebar}
              show={show}
              setShow={setShow}
              setShowCancelButton={setShowCancelButton}
            />
          </div>
        </div>

        {/* Main content area */}
        <div className="flex-1 min-h-screen overflow-x-hidden">
          <Outlet />
        </div>
      </div>

      {/* ════════════════════════════════════════
          MOBILE / TABLET  (below laptopM)
          Sticky top bar + slide-in drawer
      ════════════════════════════════════════ */}
      <div className="laptopM:hidden flex flex-col min-h-screen">

        {/* Sticky mobile top bar */}
        <div className="sticky top-0 z-40 bg-sidebar border-b border-slate-700/60 px-4 py-3
                        flex items-center gap-3 shadow-md">
          <button
            id="mobile-menu-btn"
            onClick={() => setShow(true)}
            className="p-2 rounded-lg hover:bg-sidebarHover transition-colors"
          >
            <MdDehaze className="text-slate-300 text-xl" />
          </button>
          <span className="text-white font-bold text-base tracking-tight select-none">
            Kraken
          </span>
        </div>

        {/* Drawer overlay */}
        {show && (
          <div
            className="fixed inset-0 z-50 flex"
            style={{ background: "rgba(0,0,0,0.45)" }}
          >
            {/* Sidebar panel */}
            <div className="w-72 max-w-[85vw] h-full flex-shrink-0 overflow-y-auto
                            animate-slideIn shadow-2xl">
              <Sidebar
                showSidebar={false}
                setShowSidebar={setShowSidebar}
                show={show}
                setShow={setShow}
                setShowCancelButton={setShowCancelButton}
              />
            </div>

            {/* Dismiss area */}
            <div
              className="flex-1 flex items-start justify-end p-4"
              onClick={() => { setShow(false); setShowCancelButton(false); }}
            >
              <button className="text-white bg-white/10 hover:bg-white/20 border border-white/20
                                 rounded-full p-2 transition-colors">
                <MdClose className="text-xl" />
              </button>
            </div>
          </div>
        )}

        {/* Page content */}
        <div className="flex-1">
          <Outlet />
        </div>
      </div>

    </div>
  );
}

export default Layout;
